/* eslint-disable no-template-curly-in-string */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useParams } from '@thd-olt-component-react/router';
import { Col, Row } from '@thd-olt-component-react/grid';
import { Heading } from '@thd-olt-component-react/core-ui';
import { RatingsAndReviews } from '@thd-olt-component-react/ratings-and-reviews';
import {
  arrayOf as arrayType,
  extend,
  number as numberType,
  params,
  QueryContext,
  QueryProvider,
  shape as shapeType,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { node } from 'prop-types';
import { Metadata, PprMetadata } from '@thd-olt-component-react/metadata';
import { LayoutGroup, LayoutManager } from '@thd-olt-component-react/layout-manager';
import { ReviewsRedirector, RedirectProvider } from '@thd-nucleus/redirector';
import { ProductInfoBar } from '@thd-olt-component-react/product-info-bar'
import { DynamicRecsWrapper } from '@thd-olt-component-react/thd-recs-containers';
import { RecommendationsProvider } from '@thd-olt-component-react/recommendations';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs'
import { ProductDetails } from '@thd-olt-component-react/product-details'
import { SalientPoints } from '@thd-olt-component-react/salient-points'
import { MediaGallery, MediaGalleryCarousel } from '@thd-olt-component-react/media-gallery';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { declareContexts, Hydrator } from '@thd-olt-component-react/hydrator';
import { Helmet } from 'react-helmet-async';
import { EmtLinks } from '@thd-olt-component-react/emt-links';
import { FrequentlyBoughtTogether } from '@thd-olt-component-react/frequently-bought-together';
import { FeatureBasedRecommendationsImporter } from '@thd-olt-component-react/feature-based-recommendations';
import '../styles/product-reviews.scss';

function setBrandName(brandName) {
  // eslint-disable-next-line eqeqeq
  if (brandName == undefined) {
    return '';
  }
  if (brandName !== undefined) {
    if (brandName === 'Unbranded') {
      return '';
    }
  }
  return brandName;
}

function removeDoubleSpaces(string) {
  return string.replace(/\s{2,}/g, ' ');
}

const isFromSearchEngine = () => {
  const siteList = /google.com|bing.com|yahoo.com|duckduckgo.com|aol.com/i;
  return typeof window !== 'undefined' && window?.document && siteList.test(window.document.referrer);
};

const getUrlSearchParams = (param, queryString) => {
  const searchParam = new RegExp('[?&]' + param + '=([^&#]*)').exec(queryString);
  return searchParam && decodeURI(searchParam[1]);
};
const isFromProductListAd = () => {
  const url = typeof window !== 'undefined' && window.location?.href;
  return /^Shopping/.test(getUrlSearchParams('cm_mmc', url));
};

const isFromPinterest = () => {
  const url = typeof window !== 'undefined' && window.location?.href;
  return /PIN_Shopping/.test(getUrlSearchParams('cm_mmc', url));
};

export const shouldDisplayReferrerRecommendations = () => {
  return isFromSearchEngine() || isFromProductListAd() || isFromPinterest();
};

export const ProductReviews = () => {
  declareContexts([ExperienceContext, QueryContext]);
  const { itemId, page } = useParams();
  const { pathname, search } = useLocation();
  const emtLinksPath = page ? pathname : `${pathname}/1`
  const productOptions = {
    variables: {
      itemId
    },
  };

  const ZoneCard = ({ children }) => {
    return <div className="zone-card">{children}</div>;
  };

  ZoneCard.propTypes = {
    children: node.isRequired
  };

  const disableSSR = typeof window !== 'undefined' && window.DISABLE_SSR;
  const varnish = !disableSSR;
  const store = useStore({ varnish });
  const { storeId, zipCode } = store;
  const RECS_REQUEST_KEY = 'aGAQFG4j6QtVTSWqujfFYWeIU6BR5Mee';
  const HYDRATION_STANDARD_SCROLL_BUFFER = 750;
  const resx = {
    appId: 'homedepot01',
    maxProducts: 16,
    products: itemId,
    showATC: true,
    criteo: {
      version: 'model2'
    },
    event: 'product',
    carouselOptions: {
      fullScrollSkip: 2
    }
  };

  const [recommendationsState, setRecommendationsState] = useState({
    ready: false,
  });
  const { data, loading } = useDataModel('product', productOptions);
  const { product } = data || {};
  const { identifiers } = product || {};
  let { brandName, productLabel } = identifiers || {};
  brandName = setBrandName(brandName);

  const { channel } = useContext(ExperienceContext);
  const qctx = useContext(QueryContext);
  const isMobile = channel === 'mobile';
  const assetLink = null || identifiers?.canonicalUrl;
  const schemaExclude = ['depth', 'width', 'height', 'color', 'weight'];
  const pageNumber = page === undefined ? '1' : page;
  const seoPageNumber = parseInt(pageNumber, 10);
  const pageDescription = removeDoubleSpaces(`Read page ${seoPageNumber} of our customer reviews for more information on the ${brandName} ${productLabel}.`);
  const pageTitle = removeDoubleSpaces(`Reviews for ${brandName} ${productLabel} | Pg ${seoPageNumber} - The Home Depot`);
  const [reviewTargetLink, setReviewTargetLink] = useState(assetLink && pageNumber === '1' ? '/1#ratings-and-reviews' : '/1');
  let reviewAssetLink = '';
  let qalink = '';
  if (assetLink && !assetLink.includes('reviews')) {
    reviewAssetLink = identifiers?.canonicalUrl.replace('/p/', '/p/reviews/') || assetLink;
    qalink = identifiers?.canonicalUrl.replace('/p/', '/p/questions/') || assetLink;
    qalink += '/1';
  }

  const viewFullButton = assetLink
    ? (
      <Row>
        <Col>
          <a className="bttn bttn--primary" href={assetLink}>
            <span className="bttn__content">View Full Product Details</span>
          </a>
        </Col>
      </Row>
    )
    : '';
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (data && !loading) {
        window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('seo-experience.page-load', { product, pageType: 'reviews' });
      }
    }
  }, []);
  useEffect(() => {
    if (product) {
      setRecommendationsState({
        ready: true
      });
    }
  }, [product]);

  const pprPageReturn = (number) => {
    setReviewTargetLink(number === 1 ? '/1#ratings-and-reviews' : '/1');
  }

  return (
    <div className="sui-bg-primary">
      <RedirectProvider
        pathWithQueryParams={pathname + search}
        itemId={itemId}
      >
        <ReviewsRedirector />
      </RedirectProvider>
      <Row className="grid isBound">
        <Metadata>
          <PprMetadata
            itemId={itemId}
            reviewsCanonical
            pageNumber={pageNumber}
            pageTitle={pageTitle}
            pageDescription={pageDescription}
            schemaExclude={schemaExclude}
          />
        </Metadata>
        <div className="breadcrumb">
          <Breadcrumbs itemId={itemId} />
        </div>
        <Row className="grid isBound">
          <Heading level="1" title={`Customer Reviews for ${brandName} ${productLabel}`} className="page-title" />
        </Row>
        { !isMobile && (
          <div className="info-bar">
            <ProductInfoBar itemId={itemId} />
          </div>
        )}
        <Row>
          <Col sm="6" height="200">
            { isMobile && (
              <div className="no-border">
                <ProductDetails itemId={itemId}>
                  <div>
                    <a href={assetLink}>
                      <div className="product-label">{productLabel}</div>
                    </a>
                    <ProductDetails.BrandCollection />
                    <ProductDetails.Ratings
                      target={reviewAssetLink + reviewTargetLink}
                      showBadge
                      qaselector={qalink}
                      targetURL={reviewAssetLink}
                    />
                  </div>
                </ProductDetails>
              </div>
            )}
            {!isMobile && (
              <MediaGallery itemId={itemId} />
            )}
          </Col>
          {!isMobile && (
            <Col sm="6" max-height="200" className="grid isBound">
              <div className="no-border detail-margin">
                <ProductDetails itemId={itemId}>
                  <div>
                    <a href={assetLink}>
                      <div className="product-label">{productLabel}</div>
                    </a>
                    <ProductDetails.BrandCollection />
                    <ProductDetails.Ratings
                      target={reviewAssetLink + reviewTargetLink}
                      showBadge
                      qaselector={qalink}
                      targetURL={reviewAssetLink}
                    />
                  </div>
                </ProductDetails>
                <SalientPoints itemId={itemId} max={3} />
                {viewFullButton}
              </div>
            </Col>
          )}
          { isMobile && (
            <MediaGalleryCarousel itemId={itemId} />
          )}
          <LayoutManager name="seo-ratings-reviews">
            <Row className="isBound">
              <Hydrator id="hydrator-ratings-and-reviews" className="grid">
                <LayoutGroup tag={Row} name="ratings" id="ratings-and-reviews">
                  <div className="zone-card">
                    { isMobile && (
                      viewFullButton
                    )}
                    <RatingsAndReviews itemId={itemId} seoPageNumber={seoPageNumber} pprPageReturn={pprPageReturn} />
                  </div>
                  <FrequentlyBoughtTogether
                    itemId={itemId}
                    openInNewTab
                    layoutGroup={{
                      tag: Row,
                    }}
                    dynamic={{
                      pageType: 'pip'
                    }}
                    hydrator={{
                      className: 'grid',
                      tag: ZoneCard
                    }}
                  />
                  <FeatureBasedRecommendationsImporter
                    hideOnMobile
                    itemId={itemId}
                    qctx={qctx}
                    layoutGroup={{
                      tag: Row,
                    }}
                    hydrator={{
                      tag: ZoneCard,
                      className: 'grid'
                    }}
                    dynamic={{
                      pageType: 'pip'
                    }}
                  />
                </LayoutGroup>
                <RecommendationsProvider resx={resx} ready={recommendationsState.ready}>
                  {!shouldDisplayReferrerRecommendations() && (
                    <Row>
                      <DynamicRecsWrapper
                        schemaName="pip_alternatives"
                        anchorId={itemId}
                        errorBoundary
                        requestKey={RECS_REQUEST_KEY}
                        hideATC
                        hydrator={{
                          className: 'grid',
                          tag: ZoneCard,
                          scrollBuffer: HYDRATION_STANDARD_SCROLL_BUFFER,
                          id: 'pip_alternatives'
                        }}
                      />
                    </Row>
                  )}
                </RecommendationsProvider>
                <QueryProvider
                  cacheKey="product-reviews"
                  defaultVariables={{ storeId, zipCode }}
                >
                  <LayoutGroup tag={Row} name="emt-links">
                    <EmtLinks
                      path={emtLinksPath}
                      layoutGroup={{ tag: Row }}
                      dynamic={{ pageType: 'product-reviews' }}
                      hydrator={{ className: 'grid' }}
                    />
                  </LayoutGroup>
                </QueryProvider>
              </Hydrator>
            </Row>
          </LayoutManager>
        </Row>
      </Row>
    </div>
  );
}
ProductReviews.dataModel = extend(
  {
    product: params({ itemId: stringType().isRequired() }).shape({
      itemId: stringType(),
      dataSources: stringType(),
      identifiers: shapeType({
        brandName: stringType(),
        canonicalUrl: stringType(),
        itemId: stringType(),
        modelNumber: stringType(),
        omsThdSku: stringType(),
        productLabel: stringType(),
        storeSkuNumber: stringType(),
        upcGtin13: stringType()
      }),
      media: shapeType({
        image: shapeType({
          url: stringType()
        }).client(),
        images: arrayType(shapeType({
          url: stringType()
        }))
      }),
      taxonomy: shapeType({
        breadCrumbs: arrayType(shapeType({
          label: stringType(),
          url: stringType()
        }))
      })
    }),
    reviews: params({ itemId: stringType().isRequired() }).shape({
      Results: arrayType(shapeType({
        Rating: numberType(),
        ReviewText: stringType(),
        Title: stringType(),
        UserNickname: stringType()
      }))
    })
  },
  Breadcrumbs,
  DynamicRecsWrapper,
  ProductDetails,
  PprMetadata,
  MediaGallery,
  SalientPoints,
  RatingsAndReviews,
  FeatureBasedRecommendationsImporter,
  FrequentlyBoughtTogether,
);